import { Component, NgZone, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from 'src/app/service/api.service';
import { MapsAPILoader } from '@agm/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-maps',
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.css']
})
export class MapsComponent implements OnInit {

  lat = 0;
  long = 0;
  zoom = 0;
  estadogps: string = "SP";
  jsonArray: any;
  markers = [];

  constructor(private activatedRoute: ActivatedRoute, private apiService: ApiService, private spinner: NgxSpinnerService, private mapsAPILoader: MapsAPILoader, private ngZone: NgZone) { }

  ngOnInit() {

    this.activatedRoute.params.subscribe(params => {
      this.estadogps = params['uf'];
    });

    this.spinner.show();
    this.carregarLocalizacao();

  }

  carregarLocalizacao() {
    this.jsonArray = [];
    this.apiService.getListagemId('lojistasgps', this.estadogps)
      .subscribe(
        (data) => { //start of (1)

          this.jsonArray = data;

          for (var i = 0; i < this.jsonArray.length; i++) {
            var endereco = this.jsonArray[i].endereco + ", Nº " + this.jsonArray[i].numero;
            var cidade = this.jsonArray[i].cidade + "-" + this.jsonArray[i].estado;
            this.markers.push({
              lat: this.jsonArray[i].latitude, lng: this.jsonArray[i].longetude, label: this.jsonArray[i].nome, icon: this.jsonArray[i].iconmapa,
              endereco: endereco, cidade: cidade
            })
          }

          this.visualizarMapa();

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  visualizarMapa() {
    this.lat = Number(-14.2350);
    this.long = Number(-51.9253);
    this.zoom = 5;

    //console.log(Number(this.lat));

    this.spinner.hide();
  }

}
